export const fr: Record<string, string> = {
  // ── Maturity Scoring (mat.*) ──
  'mat.resourceHeader': 'Ressource',
  'mat.allScored': 'Les {n} ressources sont notées',
  'mat.scoredOf': '{n} sur {total} notées',
  'mat.empty.title': 'Aucune ressource qualifiée pour le moment',
  'mat.empty.desc': 'Les ressources doivent être qualifiées à l’étape 2 avant de commencer la notation de maturité.',
  'mat.tooltip.1': 'Cette ressource nous manque-t-elle totalement, ou n’est-elle qu’une idée/intention ?',
  'mat.tooltip.2': 'Cette ressource existe-t-elle mais sous une forme précoce ou expérimentale — irrégulière, non documentée ou dépendante d’une seule personne ?',
  'mat.tooltip.3': 'Cette ressource est-elle fonctionnelle et reproductible, mais pas encore optimisée ni pleinement intégrée à nos façons de faire ?',
  'mat.tooltip.4': 'Cette ressource est-elle fiable, documentée, maintenue et intégrée aux opérations courantes ?',
  'mat.tooltip.5': 'Cette ressource est-elle une force manifeste — aboutie, résiliente aux changements de personnel et reconnue en interne ou en externe comme excellente ?',
  'mat.csv.empty': 'Le fichier CSV est vide ou ne contient aucune ligne de données.',
  'mat.import.imported': 'Import de {n} note{s} de maturité.',
  'mat.import.skipped': '{n} ligne(s) ignorée(s).',
  'mat.import.warnings': 'Avertissements :',
  'mat.import.failed': 'Échec de l’import : ',
  'mat.import.unknownError': 'Erreur inconnue',

  // ── Weight Scoring (weight.*) ──
  'weight.criticalityTooltip.0': 'Cette ressource n’est pas nécessaire à cette capacité.',
  'weight.criticalityTooltip.0.25': 'Si elle était supprimée, pourrions-nous obtenir le même résultat avec des ajustements mineurs ?',
  'weight.criticalityTooltip.0.5': 'Si elle était supprimée, la qualité ou l’efficacité du résultat se dégraderait-elle sensiblement ?',
  'weight.criticalityTooltip.0.75': 'Si elle était supprimée, faudrait-il un contournement ou une substitution importants pour livrer ?',
  'weight.criticalityTooltip.1': 'Si elle était supprimée, la capacité cesserait-elle effectivement de fonctionner ?',
  'weight.csv.empty': 'Le fichier CSV est vide ou ne contient aucune ligne de données.',
  'weight.import.imported': 'Import de {n} note{s} de criticité.',
  'weight.import.skipped': '{n} ligne(s) ignorée(s).',
  'weight.import.warnings': 'Avertissements :',
  'weight.import.failed': 'Échec de l’import : ',
  'weight.import.unknownError': 'Erreur inconnue',
  'weight.empty.noCaps.title': 'Aucune capacité disponible',
  'weight.empty.noCaps.desc': 'Importez des capacités dans le tableau de bord pour commencer la pondération.',
  'weight.empty.selectCap': 'Sélectionnez une capacité dans la barre latérale',
  'weight.empty.noResources.title': 'Aucune ressource liée',
  'weight.empty.noResources.desc': 'Rendez-vous à la phase de liaison pour d’abord ajouter des ressources à cette capacité.',
  'weight.noDescription': 'Aucune description disponible.',
  'weight.resourceCount': '{n} ressource{s}',
  'weight.selectedByOne': 'Sélectionnée par 1 personne',
  'weight.selectedByMany': 'Sélectionnée par {n} personnes',
  'weight.resourceNoDescription': 'Aucune description disponible pour cette ressource.',
  'weight.criticality.label': 'Criticité',
  'weight.criticality.hint': 'Quelle est la criticité de cette ressource pour la capacité ? Cliquez à nouveau pour désélectionner.',
  'weight.comments.label': 'Commentaires',
  'weight.comments.hint': 'Contexte facultatif sur la relation entre cette ressource et la capacité',
  'weight.comments.placeholder': 'Ajoutez des notes sur la contribution de cette ressource à la capacité...',

  // ── VRIO (vrio.*) ──
  'vrio.empty.noShortlist.title': 'Aucune ressource présélectionnée',
  'vrio.empty.noShortlist.desc': 'Terminez d’abord la phase de pondération. Les ressources dont la criticité médiane est > 0,5 apparaîtront ici.',
  'vrio.empty.selectResource': 'Sélectionnez une ressource dans la barre latérale à évaluer',
  'vrio.noDescription': 'Aucune description disponible.',
  'vrio.dimensionsCount': '{n}/5 dimensions',
  'vrio.composite': 'Composite :',

  'vrio.dim.inimitability.label': 'Inimitabilité',
  'vrio.dim.inimitability.desc': 'Dans quelle mesure est-il difficile pour un concurrent de reproduire la ressource ?',
  'vrio.dim.inimitability.score.1': 'Copiable facilement',
  'vrio.dim.inimitability.score.2': 'Coût modéré',
  'vrio.dim.inimitability.score.3': 'Quelques barrières',
  'vrio.dim.inimitability.score.4': 'Fortes barrières',
  'vrio.dim.inimitability.score.5': 'Barrières multiples',
  'vrio.tooltip.inimitability.0': 'Copiable facilement — aucune barrière à la reproduction',
  'vrio.tooltip.inimitability.1': 'Copiable avec un investissement modéré — quelques dépenses nécessaires',
  'vrio.tooltip.inimitability.2': 'Quelques barrières existent, mais un rattrapage reste faisable',
  'vrio.tooltip.inimitability.3': 'Fortes barrières — forte dépendance au parcours ou dissuasion économique',
  'vrio.tooltip.inimitability.4': 'Barrières multiples et dissuasion crédible — presque impossible à copier',

  'vrio.dim.durability.label': 'Durabilité',
  'vrio.dim.durability.desc': 'Quelle est la longévité de la ressource ?',
  'vrio.dim.durability.score.1': 'Quelques mois',
  'vrio.dim.durability.score.2': '1-2 ans',
  'vrio.dim.durability.score.3': '3-4 ans',
  'vrio.dim.durability.score.4': '5-7 ans',
  'vrio.dim.durability.score.5': 'Une décennie+',
  'vrio.tooltip.durability.0': 'Dépréciation rapide — la valeur s’épuise en quelques mois',
  'vrio.tooltip.durability.1': 'Courte durée — utile seulement 1 à 2 ans',
  'vrio.tooltip.durability.2': 'Durée moyenne avec entretien — 3 à 4 ans si maintenue',
  'vrio.tooltip.durability.3': 'Longue durée — conserve sa valeur 5 à 7 ans',
  'vrio.tooltip.durability.4': 'Très longue durée — la valeur persiste une décennie ou plus',

  'vrio.dim.appropriability.label': 'Appropriabilité',
  'vrio.dim.appropriability.desc': 'Qui capte la valeur ?',
  'vrio.dim.appropriability.score.1': 'Captée par d’autres',
  'vrio.dim.appropriability.score.2': 'Fuite fréquente',
  'vrio.dim.appropriability.score.3': 'Capture mixte',
  'vrio.dim.appropriability.score.4': 'Surtout l’entreprise',
  'vrio.dim.appropriability.score.5': 'Étroitement liée',
  'vrio.tooltip.appropriability.0': 'Valeur largement captée par les employés, fournisseurs ou clients',
  'vrio.tooltip.appropriability.1': 'Fuite fréquente — d’autres extraient une valeur importante',
  'vrio.tooltip.appropriability.2': 'Capture mixte — une partie de la valeur est retenue, une partie fuit',
  'vrio.tooltip.appropriability.3': 'L’entreprise capte l’essentiel de la valeur — fuite mineure',
  'vrio.tooltip.appropriability.4': 'Valeur étroitement liée à l’entreprise — fuite minimale',

  'vrio.dim.substitutability.label': 'Substituabilité',
  'vrio.dim.substitutability.desc': 'Une autre ressource peut-elle la remplacer ?',
  'vrio.dim.substitutability.score.1': 'Nombreux substituts',
  'vrio.dim.substitutability.score.2': 'Plusieurs options',
  'vrio.dim.substitutability.score.3': 'Quelques compromis',
  'vrio.dim.substitutability.score.4': 'Peu de solutions viables',
  'vrio.dim.substitutability.score.5': 'Aucun substitut',
  'vrio.tooltip.substitutability.0': 'De nombreux substituts faciles existent sur plusieurs dimensions',
  'vrio.tooltip.substitutability.1': 'Plusieurs substituts disponibles à coût modéré',
  'vrio.tooltip.substitutability.2': 'Quelques substituts existent mais avec des compromis notables',
  'vrio.tooltip.substitutability.3': 'Peu de substituts viables — le changement est coûteux',
  'vrio.tooltip.substitutability.4': 'Aucun substitut proche — ressource véritablement unique',

  'vrio.dim.competitiveSuperiority.label': 'Supériorité concurrentielle',
  'vrio.dim.competitiveSuperiority.desc': 'Quelle ressource est la meilleure ?',
  'vrio.dim.competitiveSuperiority.score.1': 'Inférieure',
  'vrio.dim.competitiveSuperiority.score.2': 'Quasi-parité',
  'vrio.dim.competitiveSuperiority.score.3': 'Parité',
  'vrio.dim.competitiveSuperiority.score.4': 'Avantage net',
  'vrio.dim.competitiveSuperiority.score.5': 'Dominante',
  'vrio.tooltip.competitiveSuperiority.0': 'Inférieure au groupe de pairs — sous la référence',
  'vrio.tooltip.competitiveSuperiority.1': 'Quasi-parité ou légèrement en dessous des pairs',
  'vrio.tooltip.competitiveSuperiority.2': 'Parité ou résultats mitigés selon les mesures',
  'vrio.tooltip.competitiveSuperiority.3': 'Avantage mesurable et net sur les concurrents',
  'vrio.tooltip.competitiveSuperiority.4': 'Dominante — surperformance répétée sur les mesures',
};

export const en: Record<string, string> = {
  // ── Maturity Scoring (mat.*) ──
  'mat.resourceHeader': 'Resource',
  'mat.allScored': 'All {n} resources scored',
  'mat.scoredOf': '{n} of {total} scored',
  'mat.empty.title': 'No qualified resources yet',
  'mat.empty.desc': 'Resources need to be qualified in Stage 2 before maturity scoring can begin.',
  'mat.tooltip.1': 'Do we lack this resource entirely, or is it only an idea/intention?',
  'mat.tooltip.2': 'Does this resource exist but in early or experimental form — inconsistent, undocumented, or dependent on one person?',
  'mat.tooltip.3': 'Is this resource functional and repeatable, but not yet optimized or fully embedded in how we work?',
  'mat.tooltip.4': 'Is this resource reliable, documented, maintained, and integrated into standard operations?',
  'mat.tooltip.5': 'Is this resource a clear strength — refined, resilient to staff changes, and recognized internally or externally as excellent?',
  'mat.csv.empty': 'CSV file is empty or has no data rows.',
  'mat.import.imported': 'Imported {n} maturity score{s}.',
  'mat.import.skipped': '{n} row(s) skipped.',
  'mat.import.warnings': 'Warnings:',
  'mat.import.failed': 'Import failed: ',
  'mat.import.unknownError': 'Unknown error',

  // ── Weight Scoring (weight.*) ──
  'weight.criticalityTooltip.0': 'This resource is not needed for this capability.',
  'weight.criticalityTooltip.0.25': 'If removed, could we deliver the same outcome with minor adjustments?',
  'weight.criticalityTooltip.0.5': 'If removed, would outcome quality or efficiency noticeably degrade?',
  'weight.criticalityTooltip.0.75': 'If removed, would we need a significant workaround or substitution to deliver at all?',
  'weight.criticalityTooltip.1': 'If removed, does the capability effectively cease to function?',
  'weight.csv.empty': 'CSV file is empty or has no data rows.',
  'weight.import.imported': 'Imported {n} criticality score{s}.',
  'weight.import.skipped': '{n} row(s) skipped.',
  'weight.import.warnings': 'Warnings:',
  'weight.import.failed': 'Import failed: ',
  'weight.import.unknownError': 'Unknown error',
  'weight.empty.noCaps.title': 'No capabilities available',
  'weight.empty.noCaps.desc': 'Upload capabilities in the Dashboard to begin weight scoring.',
  'weight.empty.selectCap': 'Select a capability from the sidebar',
  'weight.empty.noResources.title': 'No resources linked',
  'weight.empty.noResources.desc': 'Go to the Linking phase to add resources to this capability first.',
  'weight.noDescription': 'No description available.',
  'weight.resourceCount': '{n} resource{s}',
  'weight.selectedByOne': 'Selected by 1 person',
  'weight.selectedByMany': 'Selected by {n} people',
  'weight.resourceNoDescription': 'No description available for this resource.',
  'weight.criticality.label': 'Criticality',
  'weight.criticality.hint': 'How critical is this resource to the capability? Click again to deselect.',
  'weight.comments.label': 'Comments',
  'weight.comments.hint': 'Optional context about this resource-capability relationship',
  'weight.comments.placeholder': 'Add any notes about how this resource contributes to the capability...',

  // ── VRIO (vrio.*) ──
  'vrio.empty.noShortlist.title': 'No resources shortlisted',
  'vrio.empty.noShortlist.desc': 'Complete the Weight Scoring phase first. Resources with criticality median > 0.5 will appear here.',
  'vrio.empty.selectResource': 'Select a resource from the sidebar to assess',
  'vrio.noDescription': 'No description available.',
  'vrio.dimensionsCount': '{n}/5 dimensions',
  'vrio.composite': 'Composite:',

  'vrio.dim.inimitability.label': 'Inimitability',
  'vrio.dim.inimitability.desc': 'How difficult is it for a competitor to reproduce the resource?',
  'vrio.dim.inimitability.score.1': 'Trivially copyable',
  'vrio.dim.inimitability.score.2': 'Moderate spend',
  'vrio.dim.inimitability.score.3': 'Some barriers',
  'vrio.dim.inimitability.score.4': 'Strong barriers',
  'vrio.dim.inimitability.score.5': 'Multiple barriers',
  'vrio.tooltip.inimitability.0': 'Trivially copyable — no barriers to reproduction',
  'vrio.tooltip.inimitability.1': 'Copyable with moderate spend — some investment needed',
  'vrio.tooltip.inimitability.2': 'Some barriers exist, but feasible to catch up',
  'vrio.tooltip.inimitability.3': 'Strong barriers — deep path dependence or economic deterrence',
  'vrio.tooltip.inimitability.4': 'Multiple barriers and credible deterrence — nearly impossible to copy',

  'vrio.dim.durability.label': 'Durability',
  'vrio.dim.durability.desc': 'How long-lived is the resource?',
  'vrio.dim.durability.score.1': 'Months',
  'vrio.dim.durability.score.2': '1-2 years',
  'vrio.dim.durability.score.3': '3-4 years',
  'vrio.dim.durability.score.4': '5-7 years',
  'vrio.dim.durability.score.5': 'Decade+',
  'vrio.tooltip.durability.0': 'Rapidly wasting — value depletes within months',
  'vrio.tooltip.durability.1': 'Short-lived — useful for 1-2 years only',
  'vrio.tooltip.durability.2': 'Medium life with refresh — 3-4 years if maintained',
  'vrio.tooltip.durability.3': 'Long-lived — retains value for 5-7 years',
  'vrio.tooltip.durability.4': 'Very long-lived — value persists a decade or more',

  'vrio.dim.appropriability.label': 'Appropriability',
  'vrio.dim.appropriability.desc': 'Who is capturing the value?',
  'vrio.dim.appropriability.score.1': 'Others capture',
  'vrio.dim.appropriability.score.2': 'Frequent leak',
  'vrio.dim.appropriability.score.3': 'Mixed capture',
  'vrio.dim.appropriability.score.4': 'Mostly firm',
  'vrio.dim.appropriability.score.5': 'Tightly bound',
  'vrio.tooltip.appropriability.0': 'Value largely captured by employees, suppliers, or customers',
  'vrio.tooltip.appropriability.1': 'Frequent leakage — others extract significant value',
  'vrio.tooltip.appropriability.2': 'Mixed capture — some value retained, some leaked',
  'vrio.tooltip.appropriability.3': 'Mostly firm captures value — minor leakage',
  'vrio.tooltip.appropriability.4': 'Value tightly bound to the firm — minimal leakage',

  'vrio.dim.substitutability.label': 'Substitutability',
  'vrio.dim.substitutability.desc': 'Can a different resource replace it?',
  'vrio.dim.substitutability.score.1': 'Many substitutes',
  'vrio.dim.substitutability.score.2': 'Several options',
  'vrio.dim.substitutability.score.3': 'Some trade-offs',
  'vrio.dim.substitutability.score.4': 'Few viable',
  'vrio.dim.substitutability.score.5': 'No substitutes',
  'vrio.tooltip.substitutability.0': 'Many easy substitutes exist across multiple dimensions',
  'vrio.tooltip.substitutability.1': 'Several substitutes available at moderate cost',
  'vrio.tooltip.substitutability.2': 'Some substitutes exist but with notable trade-offs',
  'vrio.tooltip.substitutability.3': 'Few viable substitutes — switching is costly',
  'vrio.tooltip.substitutability.4': 'No close substitutes — truly unique resource',

  'vrio.dim.competitiveSuperiority.label': 'Competitive Superiority',
  'vrio.dim.competitiveSuperiority.desc': 'Whose resource is better?',
  'vrio.dim.competitiveSuperiority.score.1': 'Inferior',
  'vrio.dim.competitiveSuperiority.score.2': 'Parity-',
  'vrio.dim.competitiveSuperiority.score.3': 'Parity',
  'vrio.dim.competitiveSuperiority.score.4': 'Clear edge',
  'vrio.dim.competitiveSuperiority.score.5': 'Dominant',
  'vrio.tooltip.competitiveSuperiority.0': 'Inferior to peer set — below benchmark',
  'vrio.tooltip.competitiveSuperiority.1': 'Rough parity or slightly worse than peers',
  'vrio.tooltip.competitiveSuperiority.2': 'Parity or mixed results across measures',
  'vrio.tooltip.competitiveSuperiority.3': 'Clear measurable edge over competitors',
  'vrio.tooltip.competitiveSuperiority.4': 'Dominant — repeated outperformance across measures',
};
